<template>
    <div>
        <b-form
            name="paperChoicesForm"
            v-on:submit.prevent="
                mode === 'add' ? $_onAddFormat() : $_onSaveSettings()
            "
        >
            <div v-if="mode === 'add'" class="content-block">
                <paper-choice
                    ref="addForm"
                    mode="add"
                    :format="newFormat"
                    :print-configuration="printConfiguration"
                    @settings="$_onChangeAddSettings($event)"
                ></paper-choice>
                <p class="error">{{ message }}</p>
            </div>
            <div v-else :key="componentUpdateIndex" class="content-block">
                <div class="form-group">
                    <a
                        href="#"
                        @click.stop.prevent="$_onRevertToFactoryDefaultSettings"
                    >
                        {{
                            $t(
                                'printComponent.dashboard.resetTemplatesToFactory'
                            )
                        }}
                    </a>
                </div>
                <v-draggable
                    :list="userSettingsFormats"
                    handle=".fa-arrows-alt"
                >
                    <div
                        v-for="(format, index) in userSettingsFormats"
                        :key="`format_${index}`"
                        class="accordion"
                        role="tablist"
                    >
                        <b-card no-body class="mb-1">
                            <b-card-header
                                header-tag="header"
                                :class="{
                                    'p-1': true,
                                    collapsed: !accordionState[index],
                                    'not-collapsed': accordionState[index]
                                }"
                                role="tab"
                                @click="$_selectFormat(index)"
                                data-toggle="collapse"
                            >
                                <em class="fa fa-arrows-alt"></em>
                                <span>{{ format.title.toUpperCase() }}</span>
                                <div class="float-right">
                                    <a
                                        :title="
                                            $t(
                                                'printComponent.dashboard.deleteformat'
                                            )
                                        "
                                        class="pr-4"
                                        @click.stop.prevent="
                                            $_onRemoveFormat(index)
                                        "
                                    >
                                        <em class="fas fa-trash-alt fa-sm"></em>
                                    </a>
                                    <em class="fa iconCollapseExpand"></em>
                                </div>
                            </b-card-header>
                            <b-collapse
                                :id="`accordion-${index}`"
                                accordion="my-accordion"
                                v-model="accordionState[index]"
                                role="tabpanel"
                            >
                                <b-card-body>
                                    <paper-choice
                                        v-if="accordionState[index]"
                                        :format="format"
                                        @settings="
                                            $_onChangeSettings(index, $event)
                                        "
                                    ></paper-choice>
                                    <page-configuration
                                        v-if="
                                            defaultComponents &&
                                            printConfiguration &&
                                            accordionState[index]
                                        "
                                        key="custom-settings"
                                        :custom-components="
                                            format.settings.components
                                        "
                                        :default-components="defaultComponents"
                                        :print-configuration="
                                            printConfiguration
                                        "
                                        @save="
                                            $_onSaveComponentSettings(
                                                index,
                                                $event
                                            )
                                        "
                                        @update="
                                            $_onChangeComponentSettings(
                                                index,
                                                $event
                                            )
                                        "
                                        mode="custom"
                                    />
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </v-draggable>
                <b-button @click="$_onNewFormat">{{
                    $t('btnAddLabel')
                }}</b-button>
            </div>
            <div class="sticky-bottom fixed-bottom">
                <submit-cancel-remove
                    :id="`paperChoices`"
                    :is-saving="isSaving"
                    :mode="modeAddConst"
                    @cancel="$_onCancel"
                >
                </submit-cancel-remove>
            </div>
        </b-form>
    </div>
</template>

<script>
    import { MODE_ADD } from '../../../constants';

    import { merge } from 'lodash';
    import draggable from 'vuedraggable';
    import PaperChoice from './PaperChoice.vue';
    import PageConfiguration from './PageConfiguration.vue';
    import SubmitCancelRemove from '../../../components/SubmitCancelRemove.vue';
    import modalMixin from '../../../components/Mixins/ModalMixin.vue';

    export default {
        mixins: [modalMixin],
        components: {
            'paper-choice': PaperChoice,
            'page-configuration': PageConfiguration,
            'v-draggable': draggable,
            'submit-cancel-remove': SubmitCancelRemove
        },
        props: {
            settingsFormats: { type: Array, required: true },
            defaultComponents: { type: Object, required: true },
            printConfiguration: { type: Object, required: true },
            isSaving: { type: Boolean, required: false, default: true }
        },
        data() {
            return {
                // Constants
                modeAddConst: MODE_ADD,

                userSettingsFormats: null,
                accordionState: this.settingsFormats.map((format) => false),
                componentUpdateIndex: 0,
                newFormat: null,
                mode: 'edit',
                message: null
            };
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.userSettingsFormats = JSON.parse(
                    JSON.stringify(this.settingsFormats)
                );
            },
            $_onNewFormat() {
                this.newFormat = {
                    margins: {},
                    orientation: 'portrait',
                    unit: 'mm',
                    defaultZoomPercentage: 100,
                    settings: { components: {} }
                };
                this.mode = 'add';
            },
            $_onAddFormat() {
                this.$refs.addForm.validate();
                if (this.$refs.addForm.valid) {
                    this.userSettingsFormats.push(this.newFormat);
                    this.$emit('save', this.userSettingsFormats);
                    this.mode = 'edit';
                }
            },
            $_onRemoveFormat(index) {
                this.msgBoxConfirm({
                    message: `${this.$t(
                        'printComponent.dashboard.confirmDeleteFormat'
                    )}: ${this.userSettingsFormats[index].title}`
                }).then((rusure) => {
                    if (rusure) {
                        this.userSettingsFormats.splice(index, 1);
                        this.$_onSaveSettings();
                    }
                });
            },
            $_onCancel() {
                if (this.mode === 'add') {
                    this.mode = 'edit';
                } else {
                    this.$router.push({ path: '/' });
                }
            },
            $_selectFormat(index) {
                if (this.dirty) {
                    this.msgBoxConfirm({
                        message: this.$t(
                            'printComponent.dashboard.confirmSaveFormat'
                        )
                    }).then((firstSave) => {
                        if (firstSave) {
                            this.$_onSaveSettings();
                        } else {
                            this.init();
                        }
                    });
                }
                const newVal = !this.accordionState[index];
                this.accordionState = this.settingsFormats.map((format) => false);
                this.accordionState[index] = newVal;
                this.componentUpdateIndex += 1;
            },
            $_onChangeComponentSettings(index, components) {
                const settings = [...this.userSettingsFormats];
                settings[index].settings.components = components;
                this.userSettingsFormats = [...settings];
            },
            $_onSaveComponentSettings(index, components) {
                const settings = [...this.userSettingsFormats];
                settings[index].settings.components = components;
                this.$emit('save', settings);
            },
            $_onChangeSettings(index, settings) {
                merge(this.userSettingsFormats[index], settings);
            },
            $_onChangeAddSettings(data) {
                this.message = null;
                const formatTitleIsUnique = !this.userSettingsFormats.find(
                    ({ title }) => title === data.title
                );
                if (formatTitleIsUnique) {
                    merge(this.newFormat, data);
                } else {
                    this.message = this.$t(
                        'printComponent.dashboard.chooseUniqueName'
                    );
                }
            },
            $_onSaveSettings() {
                this.$emit('save', this.userSettingsFormats);
            },
            $_onRevertToFactoryDefaultSettings() {
                this.$emit('resetSettings');
            }
        },
        computed: {
            dirty: function () {
                return (
                    JSON.stringify(this.settingsFormats) !==
                    JSON.stringify(this.userSettingsFormats)
                );
            }
        }
    };
</script>

<style scoped>
.content-block {
    margin-bottom: 100px;
}
</style>
